import { NavObjectType, lddGlobalSessionInfo } from '../../Components/navigationTypes'
import { ActivityCenterContextType } from '../../Context/ActivityCenter';
import { store } from '../../redux/store';
import { ClientConnectNotificationResponse, DRNotificationResponse, NormalizedNotification, Bulletin } from './notificationsTypes';
const blogURL = "https://docs.google.com/spreadsheets/d/1ABPhoYtnj4Fb-EXqazuhZa4Umr97ZRCG0C1cmjXJ4XM/gviz/tq?tqx=out:json&tq&gid=0";

export const getMainNotifications = async(sessionInfo: lddGlobalSessionInfo): Promise<NormalizedNotification[][]> => {
    const ccNotifs = await getClientConnectNotifications(sessionInfo);
    const drNotifs = await getDRNotifications(sessionInfo);
    if (ccNotifs.length || drNotifs.length) {
        const notifications = sortNotificationsArrayByDate([...ccNotifs, ...drNotifs]);
        return notifications;
    }
    return [];
}

// API CALLS
export const getBulletins = async (): Promise<NormalizedNotification[]> => {
    try {
        const response = await fetch(blogURL);
        if (response) {
            const text = await response.text();
            const jsonString = text.substring(47).slice(0, -2);
            const json = JSON.parse(jsonString);
            const rows = json.table.rows;
            const appCode = store?.getState()?.SessionInfo?.appCode;
            var myBulletins: Array<Bulletin> = [];
            for (var i = 0; i < rows.length; i++) {
                var cols = rows[i].c;
                var release = (cols[6]) ? cols[6].v : "";
                var condition = (cols[5]) ? cols[5].v : "";
                if (release !== "uat" && release !== "live" && release !== "beta" ) continue;
                else if (window.location.href.indexOf("lawyerdonedeal.com") !== -1 && release === "uat") continue;
                if(release === "beta" && window.location.href.indexOf("rplustest") === -1) continue; // if release = beta and we aren't in beta
                if (condition > "" && condition.indexOf(`|${appCode}|`) === -1) continue;
                myBulletins.push({ id: (cols[0]) ? parseInt(cols[0].v) : 0, title: (cols[1]) ? cols[1].v : "", msg: (cols[2]) ? cols[2].v : "", date: (cols[3]) ? cols[3].f : "", open: (cols[4]) ? cols[4].v : "", condition: condition, release: release })
            }
            const sortedBulletins = sortNotificationsByDate(normalizeBulletinNotifications(myBulletins));
            return sortedBulletins;
        }
    } catch (e) {
        console.log(`failed to fetch google bulletins ${e}`);
    }
    return [];
}
const getClientConnectNotifications = async (SessionInfo: lddGlobalSessionInfo) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/getNotifications/clientconnect?SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) throw "Failed to fetch client connect notifications.";
            const sortedCols = groupNotifications(sortNotificationsByDate(normalizeClientConnectNotifications(responseJSON.result)));
            return sortedCols;
        }
    } catch (e) {
        console.log('Unable to get client connect notifications: ', e)
    }
    return [];
}

const getDRNotifications = async (SessionInfo: lddGlobalSessionInfo): Promise<NormalizedNotification[][]> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/inbox?SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = JSON.parse(await response.text());
            if (responseJSON.ok) {
                const cols = responseJSON.result;
                const normalizedCols = normalizeDRNotifications(cols);
                return normalizedCols;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return [];
}

export const getNewDRNotificationCount = async (notifications: NormalizedNotification[], SessionInfo: lddGlobalSessionInfo): Promise<number> => {
    try {
        let timeQryParam = notifications.length > 0 ? notifications[0].date : '';
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/new?SessionID=${SessionInfo.sid}&Time=${timeQryParam}`);
        if (response && response.ok) {
            const responseJSON = JSON.parse(await response.text());
            if (typeof responseJSON === 'number') {
                return responseJSON;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return 0;
}

export const getNewClientConnectNotifications = async (notifications: NormalizedNotification[], SessionInfo: lddGlobalSessionInfo) => {
    try {
        let timeQryParam = notifications.length > 0 ? notifications[0].date : '';
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/getNewNotifications/clientconnect?SessionID=${SessionInfo.sid}&Time=${timeQryParam}`;
        const response = await fetch(url)
        if (response && response.ok) {
            const text = await response.text();
            const result = JSON.parse(text);
            return result;
        } else {
            return {ok: false, error: "Internal server error"}
        }
    } catch (e) {
        console.log('Unable to get new client connect notifications: ', e)
        return { ok: false, error: e };
    }
}

export const updateNotificationIndicator = (notifications: NormalizedNotification[][]) => {
    let hasUnread = false;
    for (let notif of notifications) {
        if (!notif[0].read) {
            hasUnread = true;
            break;
        }
    }
    if (hasUnread) {
        document.getElementById("lddNotificationBadgeMainBarNew").classList.add("show");
    } else {
        document.getElementById("lddNotificationBadgeMainBarNew").classList.remove("show");
    }
}

export const markNotificationAsRead = async (SessionInfo: lddGlobalSessionInfo, normalizedNotification: NormalizedNotification): Promise<boolean> => {
    try {
        if (normalizedNotification.type === 'DR') {
            const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.firm.id}/${SessionInfo.user.account}/${normalizedNotification.msgID}/read?SessionID=${SessionInfo.sid}`;
            const options = {
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
            }
            const response = await fetch(url, options);
            if (response && response.ok) {
                const resJson = await response.json();
                return resJson.ok;
            }
        } else {
            const stringBody = JSON.stringify(normalizedNotification)
            const options = {
                method: 'PUT',
                body: stringBody,
                headers: { "Content-Type": "application/json", },
            }
            const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/updateNotification/read/clientconnect?SessionID=${SessionInfo.sid}`
            const response = await fetch(url, options);
            if (response && response.ok) {
                const resJson = await response.json();
                return resJson.ok;
            }
        }
    } catch (e) {
        console.log('unable to mark as read: ', e)
    }
    return false;
}
export const markAllNotificationsAsRead = (SessionInfo: lddGlobalSessionInfo, normalizedNotifications: NormalizedNotification[]) => {
    try {
        const stringBody = JSON.stringify(normalizedNotifications)
        const options = {
            method: 'PUT',
            body: stringBody,
            headers: { "Content-Type": "application/json", },
        }
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/updateNotification/readall/clientconnect?SessionID=${SessionInfo.sid}`
        const response = fetch(url, options);
        if (response) { return response; }
    } catch (e) {
        console.log('unable to mark as read: ', e)
    }
}
export async function checkReadBulletins(sid: string, lastLoadedBulletinId: number) {
    try {
        if (lastLoadedBulletinId === null) {
            return;
        }
        //TODO: pickup current app folder 
        var res = await fetch(`getprofile.asp?pname=BulletinsRead&SessionID=${sid}`);
        var textData = await res.text();

        const xmlParser = new DOMParser();
        const xmlData = xmlParser.parseFromString(textData, "text/xml");
        // var profile = xmlData.documentElement.selectSingleNode("Data/Root");
        var readBulletinID = -1;
        const profile = Array.from(xmlData.getElementsByTagName("Root"))
        if (profile.length > 1) {
            var id = profile[1].id;
            if (id > "") {
                readBulletinID = parseInt(id);
            }
        }
        let tmp = document.getElementById("lddNotificationBadgeMainBar");
        if (tmp) {
            if (lastLoadedBulletinId > readBulletinID) {
                tmp.classList.add("show");
            } else {
                tmp.classList.remove("show");
            }
        }
    } catch (e) {
        console.log(e)
    }
}
export async function setReadBulletins(sid: string, lastLoadedBulletin: number) {
    try {
        if (lastLoadedBulletin === null) {
            return;
        }
        // TODO: pick current app folder
        fetch(`saveprofile.asp?pname=BulletinsRead&SessionID=${sid}`, {
            method: "POST",
            body: `<Root id="${lastLoadedBulletin}"></Root>`
        });
    } catch (e) {
        console.log(e)
    }
}

// Helper Functions

const normalizeDRNotifications = (drNotifications: DRNotificationResponse[]): NormalizedNotification[][] => {
    const normalizedArray: NormalizedNotification[][] = [];
    if (!drNotifications || drNotifications.length <= 0) return normalizedArray;
    for (let i = 0; i < drNotifications.length; i++) {
        const temp: NormalizedNotification[] = [{
            type: "DR",
            title: drNotifications[i].MsgType == '5' ? "Builder" : "Lender",
            msgType: drNotifications[i].MsgType,
            message: drNotifications[i].ProjectName,
            date: drNotifications[i].AvailableDate,
            read: drNotifications[i].ReadStatus == 1 || drNotifications[i].ReadStatus == 3, // read or closed
            readStatus: drNotifications[i].ReadStatus,
            clientName: drNotifications[i].Description,
            appId: drNotifications[i].AppID ? String(drNotifications[i].AppID) : null,
            fileNo: drNotifications[i].FileNum,
            msgID: String(drNotifications[i].MsgID),
            builder: drNotifications[i].Builder,
            lender: drNotifications[i].MsgType === '1' ? drNotifications[i].BankName : drNotifications[i].SenderName,
            matterID: drNotifications[i].MatterID,
            lawyerId: drNotifications[i].LSUCID,
            srcApp: drNotifications[i].SrcApp,
        }];
        normalizedArray.push(temp);
    }
    return normalizedArray;
}

const normalizeClientConnectNotifications = (ccNotifResponse: ClientConnectNotificationResponse[]): NormalizedNotification[] => {
    const normalizedArray: NormalizedNotification[] = [];
    if (ccNotifResponse && ccNotifResponse.length !== 0) {
        for (let i = 0; i < ccNotifResponse.length; i++) {
            const temp: NormalizedNotification = {
                type: 'ClientConnect',
                title: ccNotifResponse[i].Action,
                message: ccNotifResponse[i].Message,
                date: ccNotifResponse[i].CreatedDate,
                read: ccNotifResponse[i].Read,
                clientName: ccNotifResponse[i].ClientName,
                fileNo: ccNotifResponse[i].FileNo,
                appId: ccNotifResponse[i].AppId,
                rowKey: ccNotifResponse[i].rowKey,
                partitionKey: ccNotifResponse[i].partitionKey
            }
            normalizedArray.push(temp)
        }
    }
    return normalizedArray;
}
const normalizeBulletinNotifications = (bulletins: Bulletin[]): NormalizedNotification[] => {
    const normalizedArray: NormalizedNotification[] = [];
    for (let i = 0; i < bulletins.length; i++) {
        const temp: NormalizedNotification = {
            id: bulletins[i].id,
            type: 'Bulletin',
            title: bulletins[i].title,
            message: bulletins[i].msg,
            date: bulletins[i].date,
            read: true,
            clientName: '',
            fileNo: '',
            link: bulletins[i].open
        }
        normalizedArray.push(temp)
    }
    return normalizedArray;
}
const sortNotificationsByDate = (notifications: NormalizedNotification[]) => {
    const sortedArray: NormalizedNotification[] = [...notifications];
    sortedArray.sort(function (a, b) {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        return aDate > bDate ? -1 : 0;
    });

    return sortedArray;
}

const sortNotificationsArrayByDate = (notifications: NormalizedNotification[][]): NormalizedNotification[][] => {
    const sortedArray: NormalizedNotification[][] = [...notifications];

    sortedArray.sort((a, b) => b[0].date > a[0].date ? 0 : -1);

    return sortedArray;
}

export const createSubarrays = (array: any[], n: number): any[][] => {
    const subarrays = [];
    for (let i = 0; i < array.length; i += n) {
        subarrays.push(array.slice(i, i + n));
    }
    return subarrays;
}

function isStringValid(str: string): boolean {
    return str && str!=='NULL' && str!=='null';
}

function renderDRMessage(data: NormalizedNotification): string {
    if (data.type !== 'DR') return;

    const commonPrefix = isStringValid(data.clientName) ? ` for ${data.clientName}` : '';
    const commonSuffix = ` regarding ${data.message}.`;

    if (data.title === 'Lender') {
        const action = data.readStatus === 0 ? 'sent you' : 'updated';
        return `${data.lender} has ${action} new mortgage instructions${commonPrefix}.`;
    }

    if (data.title === 'Builder') {
        const userAction = data.readStatus === 0 ? 'received a new deal' : 'received an update';
        const builderAction =  data.readStatus === 0 ? 'sent you a new deal' : 'updated information';
        const builderPart = isStringValid(data.builder) ? `${data.builder} has ${builderAction} for ${data.clientName}${commonSuffix}` : `You have ${userAction}${commonPrefix}${commonSuffix}`;
        return builderPart;
    }
}

export const addNotificationAlertToActivityCenter = async (numberOfNewNotifications: number, activityCenterAdd: ActivityCenterContextType["Add"], notifications: NormalizedNotification[][]): Promise<string> => {

    const retVal = numberOfNewNotifications === 1 ? (
            notifications[0][0].type === 'DR' ? renderDRMessage(notifications[0][0]) : `${notifications[0][0].clientName} ${notifications[0][0].message}.`
        )
         :
        `There are ${numberOfNewNotifications} new Notifications.`;

    activityCenterAdd(retVal, undefined, 'notification', undefined); // consider changing icon
    return retVal;
}

function groupNotifications(notifications) {
    const grouped = [];

    notifications.forEach(notification => {
        const { title, date, fileNo, clientName } = notification;
        const dayOfMonth = new Date(date).getDate();

        // Check if there's already a group for the title and day
        const existingGroup = grouped.find(group => (
            group[0]?.fileNo === fileNo &&
            group[0]?.title === title &&
            group[0]?.clientName === clientName &&
            new Date(group[0]?.date).getDate() === dayOfMonth
        ));

        // If a group exists, add the notification to it
        if (existingGroup) {
            existingGroup.push(notification);
        } else {
            // Otherwise, create a new group
            grouped.push([notification]);
        }
    });

    return grouped;
}

/**
 * Reduce dimension to 1-d
 */
export function flattenGroupedNotifications(groupedNotifications: NormalizedNotification[][]): NormalizedNotification[] {
    return groupedNotifications.reduce((flattened, group) => flattened.concat(group), []);
}

type FileMatchType = {
    AppID: number,
    FileNum: string,
    ClientName: string,
    PropertyAddress: string,
    RANK: number,
}

/**
 * Fuzzy match a DR Builder message to RPW files
 * @param msgID - dr MsgID
 * @param SessionInfo - Session info
 * @returns a list of matched files, with rw file's AppID, ClientName, PropertyAddress
 */
export const fuzzyMatchToRW = async (msgID: string, SessionInfo: lddGlobalSessionInfo): Promise<FileMatchType[]> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/match?MsgID=${msgID}&SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = JSON.parse(await response.text());
            if (responseJSON.ok) {
                const cols = responseJSON.result;
                return cols;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return [];
}

/**
 * RPW file info linked with the msgID
 */
export const getLinkedRWFile = async (msgID: string, SessionInfo: lddGlobalSessionInfo): Promise<any> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/link?MsgID=${msgID}&SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = JSON.parse(await response.text());
            if (responseJSON.ok) {
                const res = responseJSON.result;
                return res;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return null;
}

export const drBuilderNavObject = (appID: string): NavObjectType => {
    const drNavObject: NavObjectType = {
        component: 'main',
        url: 'lfmaster.asp',
        label: "From Vendor",
        reactFrame: "builderdoc",
        init: true,
        params: {
            tb: "TPAppXML",
            formasp: "purfileedit",
            id: appID
        },
        controller: {
            tabName: "Documents",
        }
    };
    return drNavObject;
}

/**
 * To create a new RW file from the inbox
 * @returns nav object
 */
export const createNewFileFromInbox = async (msgID: string, mergeParts: string, formData: FormData, sessionInfo: lddGlobalSessionInfo): Promise<NavObjectType> => {
    let navObj: NavObjectType;
    let newAppID: string;
    const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/purplusweb/NewLiveFormApp.asp?Province=${sessionInfo.appProvinceShort}&SessionID=${sessionInfo.sid}`;
    const options = {
        method: 'POST',
        body: formData,
    }
    try {
        const res = await fetch(url, options);
        if (res.ok) {
            const resJson = await res.json();
            if (resJson && resJson.ok) {
                newAppID = resJson.result;
            }
        }
    } catch (e) {
        console.log(e);
    }
    
    if (newAppID > '') {
        navObj = {
            component: "main",
            url: "lfmaster.asp",
            controller: {
                tabName: "Basic",
                tabNumber: 0,
                refresh: true
            },
            params: {
                formasp: "purfileedit",
                tb: "TPAppXML",
                id: newAppID,
                onload: `MergeVIPData(${msgID},\"${mergeParts}\",0);SetPageDirty();`,
                ReactDocument: "-1"
            },
            };
    } else {
        navObj = {
            component: 'main',
            url: "lfmaster.asp",
            params: {
                formasp: "purfilenew",
                src: "NewLiveFormapp.asp",
                onload: `MergeVIPData(${msgID},\"${mergeParts}\",0);SetPageDirty();`,
            }
        };
    }
    return navObj;
}